/* @jsx h */
import { defineComponent, h } from "vue";
import { AppLanding } from "./AppLanding";
export { AppLanding } from "./AppLanding";

export const LandingPage = defineComponent({
  name: "Landing",
  setup() {
    return () => <AppLanding />;
  },
});
